
import AnnouncementBar from '../../components/feature/AnnouncementBar';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TopProductsSection from './components/TopProductsSection';
import AboutBanner from './components/AboutBanner';
import PromoBanners from './components/PromoBanners';
import StoreSection from './components/StoreSection';
import BrandsSection from './components/BrandsSection';
import CollectionsSection from './components/CollectionsSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <AnnouncementBar />
      <Navbar />
      <main>
        <HeroSection />
        <TopProductsSection />
        <AboutBanner />
        <PromoBanners />
        <StoreSection />
        <BrandsSection />
        <CollectionsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
